/* jshint ignore:start */
import Component from 'metal-component';
import Soy from 'metal-soy';

var templates;
goog.loadModule(function(exports) {
var soy = goog.require('soy');
var soydata = goog.require('soydata');
// This file was automatically generated from DocumentLibrary.soy.
// Please don't edit this file by hand.

/**
 * @fileoverview Templates in namespace DocumentLibrary.
 * @public
 */

goog.module('DocumentLibrary.incrementaldom');

goog.require('goog.soy.data.SanitizedContent');
goog.require('goog.string');
var incrementalDom = goog.require('incrementaldom');
goog.require('soy.asserts');
var soyIdom = goog.require('soy.idom');

var $templateAlias1 = Soy.getTemplate('FieldBase.incrementaldom', 'render');


/**
 * @param {{
 *  name: (!goog.soy.data.SanitizedContent|string),
 *  spritemap: (!goog.soy.data.SanitizedContent|string),
 *  _handleClearButtonClicked: (*|null|undefined),
 *  _handleSelectButtonClicked: (*|null|undefined),
 *  clearButtonAriaLabel: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  displayErrors: (boolean|null|undefined),
 *  errorMessage: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  fileEntryTitle: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  fileEntryURL: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  id: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  label: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  placeholder: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  readOnly: (boolean|null|undefined),
 *  repeatable: (boolean|null|undefined),
 *  required: (boolean|null|undefined),
 *  showLabel: (boolean|null|undefined),
 *  tip: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  tooltip: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  valid: (boolean|null|undefined),
 *  value: (?),
 *  visible: (boolean|null|undefined)
 * }} opt_data
 * @param {Object<string, *>=} opt_ijData
 * @param {Object<string, *>=} opt_ijData_deprecated
 * @return {void}
 * @suppress {checkTypes}
 */
function $render(opt_data, opt_ijData, opt_ijData_deprecated) {
  opt_ijData = opt_ijData_deprecated || opt_ijData;
  /** @type {!goog.soy.data.SanitizedContent|string} */
  var name = soy.asserts.assertType(goog.isString(opt_data.name) || opt_data.name instanceof goog.soy.data.SanitizedContent, 'name', opt_data.name, '!goog.soy.data.SanitizedContent|string');
  /** @type {!goog.soy.data.SanitizedContent|string} */
  var spritemap = soy.asserts.assertType(goog.isString(opt_data.spritemap) || opt_data.spritemap instanceof goog.soy.data.SanitizedContent, 'spritemap', opt_data.spritemap, '!goog.soy.data.SanitizedContent|string');
  /** @type {*|null|undefined} */
  var _handleClearButtonClicked = opt_data._handleClearButtonClicked;
  /** @type {*|null|undefined} */
  var _handleSelectButtonClicked = opt_data._handleSelectButtonClicked;
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var clearButtonAriaLabel = soy.asserts.assertType(opt_data.clearButtonAriaLabel == null || (goog.isString(opt_data.clearButtonAriaLabel) || opt_data.clearButtonAriaLabel instanceof goog.soy.data.SanitizedContent), 'clearButtonAriaLabel', opt_data.clearButtonAriaLabel, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {boolean|null|undefined} */
  var displayErrors = soy.asserts.assertType(opt_data.displayErrors == null || (goog.isBoolean(opt_data.displayErrors) || opt_data.displayErrors === 1 || opt_data.displayErrors === 0), 'displayErrors', opt_data.displayErrors, 'boolean|null|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var errorMessage = soy.asserts.assertType(opt_data.errorMessage == null || (goog.isString(opt_data.errorMessage) || opt_data.errorMessage instanceof goog.soy.data.SanitizedContent), 'errorMessage', opt_data.errorMessage, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var fileEntryTitle = soy.asserts.assertType(opt_data.fileEntryTitle == null || (goog.isString(opt_data.fileEntryTitle) || opt_data.fileEntryTitle instanceof goog.soy.data.SanitizedContent), 'fileEntryTitle', opt_data.fileEntryTitle, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var fileEntryURL = soy.asserts.assertType(opt_data.fileEntryURL == null || (goog.isString(opt_data.fileEntryURL) || opt_data.fileEntryURL instanceof goog.soy.data.SanitizedContent), 'fileEntryURL', opt_data.fileEntryURL, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var id = soy.asserts.assertType(opt_data.id == null || (goog.isString(opt_data.id) || opt_data.id instanceof goog.soy.data.SanitizedContent), 'id', opt_data.id, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var label = soy.asserts.assertType(opt_data.label == null || (goog.isString(opt_data.label) || opt_data.label instanceof goog.soy.data.SanitizedContent), 'label', opt_data.label, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var placeholder = soy.asserts.assertType(opt_data.placeholder == null || (goog.isString(opt_data.placeholder) || opt_data.placeholder instanceof goog.soy.data.SanitizedContent), 'placeholder', opt_data.placeholder, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {boolean|null|undefined} */
  var readOnly = soy.asserts.assertType(opt_data.readOnly == null || (goog.isBoolean(opt_data.readOnly) || opt_data.readOnly === 1 || opt_data.readOnly === 0), 'readOnly', opt_data.readOnly, 'boolean|null|undefined');
  /** @type {boolean|null|undefined} */
  var repeatable = soy.asserts.assertType(opt_data.repeatable == null || (goog.isBoolean(opt_data.repeatable) || opt_data.repeatable === 1 || opt_data.repeatable === 0), 'repeatable', opt_data.repeatable, 'boolean|null|undefined');
  /** @type {boolean|null|undefined} */
  var required = soy.asserts.assertType(opt_data.required == null || (goog.isBoolean(opt_data.required) || opt_data.required === 1 || opt_data.required === 0), 'required', opt_data.required, 'boolean|null|undefined');
  /** @type {boolean|null|undefined} */
  var showLabel = soy.asserts.assertType(opt_data.showLabel == null || (goog.isBoolean(opt_data.showLabel) || opt_data.showLabel === 1 || opt_data.showLabel === 0), 'showLabel', opt_data.showLabel, 'boolean|null|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var tip = soy.asserts.assertType(opt_data.tip == null || (goog.isString(opt_data.tip) || opt_data.tip instanceof goog.soy.data.SanitizedContent), 'tip', opt_data.tip, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var tooltip = soy.asserts.assertType(opt_data.tooltip == null || (goog.isString(opt_data.tooltip) || opt_data.tooltip instanceof goog.soy.data.SanitizedContent), 'tooltip', opt_data.tooltip, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {boolean|null|undefined} */
  var valid = soy.asserts.assertType(opt_data.valid == null || (goog.isBoolean(opt_data.valid) || opt_data.valid === 1 || opt_data.valid === 0), 'valid', opt_data.valid, 'boolean|null|undefined');
  /** @type {?} */
  var value = opt_data.value;
  /** @type {boolean|null|undefined} */
  var visible = soy.asserts.assertType(opt_data.visible == null || (goog.isBoolean(opt_data.visible) || opt_data.visible === 1 || opt_data.visible === 0), 'visible', opt_data.visible, 'boolean|null|undefined');
  var param348 = function() {
    $content(opt_data, null, opt_ijData);
  };
  $templateAlias1({contentRenderer: param348, displayErrors: displayErrors, errorMessage: errorMessage, id: id, label: label, name: name, readOnly: readOnly, repeatable: repeatable, required: required, showLabel: showLabel, spritemap: spritemap, tip: tip, tooltip: tooltip, valid: valid, visible: visible}, null, opt_ijData);
}
exports.render = $render;
/**
 * @typedef {{
 *  name: (!goog.soy.data.SanitizedContent|string),
 *  spritemap: (!goog.soy.data.SanitizedContent|string),
 *  _handleClearButtonClicked: (*|null|undefined),
 *  _handleSelectButtonClicked: (*|null|undefined),
 *  clearButtonAriaLabel: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  displayErrors: (boolean|null|undefined),
 *  errorMessage: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  fileEntryTitle: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  fileEntryURL: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  id: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  label: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  placeholder: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  readOnly: (boolean|null|undefined),
 *  repeatable: (boolean|null|undefined),
 *  required: (boolean|null|undefined),
 *  showLabel: (boolean|null|undefined),
 *  tip: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  tooltip: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  valid: (boolean|null|undefined),
 *  value: (?),
 *  visible: (boolean|null|undefined)
 * }}
 */
$render.Params;
if (goog.DEBUG) {
  $render.soyTemplateName = 'DocumentLibrary.render';
}


/**
 * @param {{
 *  name: (!goog.soy.data.SanitizedContent|string),
 *  spritemap: (!goog.soy.data.SanitizedContent|string),
 *  _handleClearButtonClicked: (*|null|undefined),
 *  _handleSelectButtonClicked: (*|null|undefined),
 *  clearButtonAriaLabel: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  fileEntryTitle: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  fileEntryURL: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  id: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  placeholder: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  readOnly: (boolean|null|undefined),
 *  value: (?)
 * }} opt_data
 * @param {Object<string, *>=} opt_ijData
 * @param {Object<string, *>=} opt_ijData_deprecated
 * @return {void}
 * @suppress {checkTypes}
 */
function $content(opt_data, opt_ijData, opt_ijData_deprecated) {
  opt_ijData = opt_ijData_deprecated || opt_ijData;
  /** @type {!goog.soy.data.SanitizedContent|string} */
  var name = soy.asserts.assertType(goog.isString(opt_data.name) || opt_data.name instanceof goog.soy.data.SanitizedContent, 'name', opt_data.name, '!goog.soy.data.SanitizedContent|string');
  /** @type {!goog.soy.data.SanitizedContent|string} */
  var spritemap = soy.asserts.assertType(goog.isString(opt_data.spritemap) || opt_data.spritemap instanceof goog.soy.data.SanitizedContent, 'spritemap', opt_data.spritemap, '!goog.soy.data.SanitizedContent|string');
  /** @type {*|null|undefined} */
  var _handleClearButtonClicked = opt_data._handleClearButtonClicked;
  /** @type {*|null|undefined} */
  var _handleSelectButtonClicked = opt_data._handleSelectButtonClicked;
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var clearButtonAriaLabel = soy.asserts.assertType(opt_data.clearButtonAriaLabel == null || (goog.isString(opt_data.clearButtonAriaLabel) || opt_data.clearButtonAriaLabel instanceof goog.soy.data.SanitizedContent), 'clearButtonAriaLabel', opt_data.clearButtonAriaLabel, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var fileEntryTitle = soy.asserts.assertType(opt_data.fileEntryTitle == null || (goog.isString(opt_data.fileEntryTitle) || opt_data.fileEntryTitle instanceof goog.soy.data.SanitizedContent), 'fileEntryTitle', opt_data.fileEntryTitle, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var fileEntryURL = soy.asserts.assertType(opt_data.fileEntryURL == null || (goog.isString(opt_data.fileEntryURL) || opt_data.fileEntryURL instanceof goog.soy.data.SanitizedContent), 'fileEntryURL', opt_data.fileEntryURL, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var id = soy.asserts.assertType(opt_data.id == null || (goog.isString(opt_data.id) || opt_data.id instanceof goog.soy.data.SanitizedContent), 'id', opt_data.id, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var placeholder = soy.asserts.assertType(opt_data.placeholder == null || (goog.isString(opt_data.placeholder) || opt_data.placeholder instanceof goog.soy.data.SanitizedContent), 'placeholder', opt_data.placeholder, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {boolean|null|undefined} */
  var readOnly = soy.asserts.assertType(opt_data.readOnly == null || (goog.isBoolean(opt_data.readOnly) || opt_data.readOnly === 1 || opt_data.readOnly === 0), 'readOnly', opt_data.readOnly, 'boolean|null|undefined');
  /** @type {?} */
  var value = opt_data.value;
  var attributes__soy391 = function() {
    if (id) {
      incrementalDom.attr('id', id);
    }
    incrementalDom.attr('name', name);
    incrementalDom.attr('type', 'hidden');
    if (placeholder) {
      incrementalDom.attr('placeholder', placeholder);
    }
    if (value) {
      incrementalDom.attr('value', value);
    } else {
      incrementalDom.attr('value', '');
    }
  };
  incrementalDom.elementOpenStart('div');
      incrementalDom.attr('class', 'liferay-ddm-form-field-document-library');
  incrementalDom.elementOpenEnd();
    if (fileEntryURL && readOnly) {
      $card_item(opt_data, null, opt_ijData);
    } else {
      incrementalDom.elementOpenStart('div');
          incrementalDom.attr('class', 'input-group');
      incrementalDom.elementOpenEnd();
        incrementalDom.elementOpenStart('div');
            incrementalDom.attr('class', 'input-group-item input-group-prepend');
        incrementalDom.elementOpenEnd();
          incrementalDom.elementOpenStart('input');
              incrementalDom.attr('aria-hidden', 'true');
              incrementalDom.attr('class', 'field form-control');
              incrementalDom.attr('disabled', '');
              incrementalDom.attr('id', name + 'inputFile');
              incrementalDom.attr('type', 'text');
              if (fileEntryTitle) {
                incrementalDom.attr('value', fileEntryTitle);
              } else {
                incrementalDom.attr('value', '');
              }
          incrementalDom.elementOpenEnd();
          incrementalDom.elementClose('input');
        incrementalDom.elementClose('div');
        $button_group(opt_data, null, opt_ijData);
      incrementalDom.elementClose('div');
    }
    incrementalDom.elementOpenStart('input');
        attributes__soy391();
    incrementalDom.elementOpenEnd();
    incrementalDom.elementClose('input');
  incrementalDom.elementClose('div');
}
exports.content = $content;
/**
 * @typedef {{
 *  name: (!goog.soy.data.SanitizedContent|string),
 *  spritemap: (!goog.soy.data.SanitizedContent|string),
 *  _handleClearButtonClicked: (*|null|undefined),
 *  _handleSelectButtonClicked: (*|null|undefined),
 *  clearButtonAriaLabel: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  fileEntryTitle: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  fileEntryURL: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  id: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  placeholder: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  readOnly: (boolean|null|undefined),
 *  value: (?)
 * }}
 */
$content.Params;
if (goog.DEBUG) {
  $content.soyTemplateName = 'DocumentLibrary.content';
}


/**
 * @param {{
 *  _handleClearButtonClicked: (*|null|undefined),
 *  _handleSelectButtonClicked: (*|null|undefined),
 *  clearButtonAriaLabel: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  readOnly: (boolean|null|undefined),
 *  fileEntryTitle: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  spritemap: (!goog.soy.data.SanitizedContent|string)
 * }} opt_data
 * @param {Object<string, *>=} opt_ijData
 * @param {Object<string, *>=} opt_ijData_deprecated
 * @return {void}
 * @suppress {checkTypes}
 */
function $button_group(opt_data, opt_ijData, opt_ijData_deprecated) {
  opt_ijData = opt_ijData_deprecated || opt_ijData;
  /** @type {*|null|undefined} */
  var _handleClearButtonClicked = opt_data._handleClearButtonClicked;
  /** @type {*|null|undefined} */
  var _handleSelectButtonClicked = opt_data._handleSelectButtonClicked;
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var clearButtonAriaLabel = soy.asserts.assertType(opt_data.clearButtonAriaLabel == null || (goog.isString(opt_data.clearButtonAriaLabel) || opt_data.clearButtonAriaLabel instanceof goog.soy.data.SanitizedContent), 'clearButtonAriaLabel', opt_data.clearButtonAriaLabel, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {boolean|null|undefined} */
  var readOnly = soy.asserts.assertType(opt_data.readOnly == null || (goog.isBoolean(opt_data.readOnly) || opt_data.readOnly === 1 || opt_data.readOnly === 0), 'readOnly', opt_data.readOnly, 'boolean|null|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var fileEntryTitle = soy.asserts.assertType(opt_data.fileEntryTitle == null || (goog.isString(opt_data.fileEntryTitle) || opt_data.fileEntryTitle instanceof goog.soy.data.SanitizedContent), 'fileEntryTitle', opt_data.fileEntryTitle, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|string} */
  var spritemap = soy.asserts.assertType(goog.isString(opt_data.spritemap) || opt_data.spritemap instanceof goog.soy.data.SanitizedContent, 'spritemap', opt_data.spritemap, '!goog.soy.data.SanitizedContent|string');
  incrementalDom.elementOpenStart('div');
      incrementalDom.attr('class', 'input-group-append input-group-item input-group-item-shrink');
  incrementalDom.elementOpenEnd();
    incrementalDom.elementOpenStart('button');
        incrementalDom.attr('class', 'btn btn-secondary select-button');
        incrementalDom.attr('data-onclick', _handleSelectButtonClicked);
        if (readOnly) {
          incrementalDom.attr('disabled', '');
        }
        incrementalDom.attr('type', 'button');
    incrementalDom.elementOpenEnd();
      incrementalDom.elementOpenStart('span');
          incrementalDom.attr('class', 'lfr-btn-label');
      incrementalDom.elementOpenEnd();
        /** @desc  */
        var MSG_EXTERNAL_7982607155521959690 = Liferay.Language.get('select');
        incrementalDom.text(goog.string.unescapeEntities(MSG_EXTERNAL_7982607155521959690));
      incrementalDom.elementClose('span');
    incrementalDom.elementClose('button');
  incrementalDom.elementClose('div');
  if (fileEntryTitle) {
    incrementalDom.elementOpenStart('div');
        incrementalDom.attr('class', 'input-group-append input-group-item input-group-item-shrink');
    incrementalDom.elementOpenEnd();
      incrementalDom.elementOpenStart('button');
          incrementalDom.attr('aria-label', clearButtonAriaLabel);
          incrementalDom.attr('class', 'btn btn-secondary clear-button');
          incrementalDom.attr('data-onclick', _handleClearButtonClicked);
          incrementalDom.attr('type', 'button');
      incrementalDom.elementOpenEnd();
        incrementalDom.elementOpenStart('svg');
            incrementalDom.attr('class', 'lexicon-icon');
        incrementalDom.elementOpenEnd();
          incrementalDom.elementOpenStart('use');
              incrementalDom.attr('xlink:href', spritemap + '#times');
          incrementalDom.elementOpenEnd();
          incrementalDom.elementClose('use');
        incrementalDom.elementClose('svg');
      incrementalDom.elementClose('button');
    incrementalDom.elementClose('div');
  }
}
exports.button_group = $button_group;
/**
 * @typedef {{
 *  _handleClearButtonClicked: (*|null|undefined),
 *  _handleSelectButtonClicked: (*|null|undefined),
 *  clearButtonAriaLabel: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  readOnly: (boolean|null|undefined),
 *  fileEntryTitle: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  spritemap: (!goog.soy.data.SanitizedContent|string)
 * }}
 */
$button_group.Params;
if (goog.DEBUG) {
  $button_group.soyTemplateName = 'DocumentLibrary.button_group';
}


/**
 * @param {{
 *  spritemap: (!goog.soy.data.SanitizedContent|string),
 *  fileEntryTitle: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  fileEntryURL: (!goog.soy.data.SanitizedContent|null|string|undefined)
 * }} opt_data
 * @param {Object<string, *>=} opt_ijData
 * @param {Object<string, *>=} opt_ijData_deprecated
 * @return {void}
 * @suppress {checkTypes}
 */
function $card_item(opt_data, opt_ijData, opt_ijData_deprecated) {
  opt_ijData = opt_ijData_deprecated || opt_ijData;
  /** @type {!goog.soy.data.SanitizedContent|string} */
  var spritemap = soy.asserts.assertType(goog.isString(opt_data.spritemap) || opt_data.spritemap instanceof goog.soy.data.SanitizedContent, 'spritemap', opt_data.spritemap, '!goog.soy.data.SanitizedContent|string');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var fileEntryTitle = soy.asserts.assertType(opt_data.fileEntryTitle == null || (goog.isString(opt_data.fileEntryTitle) || opt_data.fileEntryTitle instanceof goog.soy.data.SanitizedContent), 'fileEntryTitle', opt_data.fileEntryTitle, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var fileEntryURL = soy.asserts.assertType(opt_data.fileEntryURL == null || (goog.isString(opt_data.fileEntryURL) || opt_data.fileEntryURL instanceof goog.soy.data.SanitizedContent), 'fileEntryURL', opt_data.fileEntryURL, '!goog.soy.data.SanitizedContent|null|string|undefined');
  incrementalDom.elementOpenStart('div');
      incrementalDom.attr('class', 'card card-horizontal');
  incrementalDom.elementOpenEnd();
    incrementalDom.elementOpenStart('div');
        incrementalDom.attr('class', 'card-row card-row-padded');
    incrementalDom.elementOpenEnd();
      incrementalDom.elementOpenStart('div');
          incrementalDom.attr('class', 'card-col-content card-col-gutters');
      incrementalDom.elementOpenEnd();
        incrementalDom.elementOpenStart('h4');
            incrementalDom.attr('class', 'truncate-text');
            incrementalDom.attr('title', fileEntryTitle);
        incrementalDom.elementOpenEnd();
          soyIdom.print(fileEntryTitle);
        incrementalDom.elementClose('h4');
      incrementalDom.elementClose('div');
      incrementalDom.elementOpenStart('div');
          incrementalDom.attr('class', 'card-col-field');
      incrementalDom.elementOpenEnd();
        incrementalDom.elementOpenStart('a');
            incrementalDom.attr('download', fileEntryTitle);
            incrementalDom.attr('href', fileEntryURL);
        incrementalDom.elementOpenEnd();
          incrementalDom.elementOpenStart('svg');
              incrementalDom.attr('class', 'lexicon-icon');
          incrementalDom.elementOpenEnd();
            incrementalDom.elementOpenStart('use');
                incrementalDom.attr('xlink:href', spritemap + '#download');
            incrementalDom.elementOpenEnd();
            incrementalDom.elementClose('use');
          incrementalDom.elementClose('svg');
        incrementalDom.elementClose('a');
      incrementalDom.elementClose('div');
    incrementalDom.elementClose('div');
  incrementalDom.elementClose('div');
}
exports.card_item = $card_item;
/**
 * @typedef {{
 *  spritemap: (!goog.soy.data.SanitizedContent|string),
 *  fileEntryTitle: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  fileEntryURL: (!goog.soy.data.SanitizedContent|null|string|undefined)
 * }}
 */
$card_item.Params;
if (goog.DEBUG) {
  $card_item.soyTemplateName = 'DocumentLibrary.card_item';
}

exports.render.params = ["name","spritemap","_handleClearButtonClicked","_handleSelectButtonClicked","clearButtonAriaLabel","displayErrors","errorMessage","fileEntryTitle","fileEntryURL","id","label","placeholder","readOnly","repeatable","required","showLabel","tip","tooltip","valid","value","visible"];
exports.render.types = {"name":"string","spritemap":"string","_handleClearButtonClicked":"any","_handleSelectButtonClicked":"any","clearButtonAriaLabel":"string","displayErrors":"bool","errorMessage":"string","fileEntryTitle":"string","fileEntryURL":"string","id":"string","label":"string","placeholder":"string","readOnly":"bool","repeatable":"bool","required":"bool","showLabel":"bool","tip":"string","tooltip":"string","valid":"bool","value":"?","visible":"bool"};
exports.content.params = ["name","spritemap","_handleClearButtonClicked","_handleSelectButtonClicked","clearButtonAriaLabel","fileEntryTitle","fileEntryURL","id","placeholder","readOnly","value"];
exports.content.types = {"name":"string","spritemap":"string","_handleClearButtonClicked":"any","_handleSelectButtonClicked":"any","clearButtonAriaLabel":"string","fileEntryTitle":"string","fileEntryURL":"string","id":"string","placeholder":"string","readOnly":"bool","value":"?"};
exports.button_group.params = ["_handleClearButtonClicked","_handleSelectButtonClicked","clearButtonAriaLabel","readOnly","fileEntryTitle","spritemap"];
exports.button_group.types = {"_handleClearButtonClicked":"any","_handleSelectButtonClicked":"any","clearButtonAriaLabel":"string","readOnly":"bool","fileEntryTitle":"string","spritemap":"string"};
exports.card_item.params = ["spritemap","fileEntryTitle","fileEntryURL"];
exports.card_item.types = {"spritemap":"string","fileEntryTitle":"string","fileEntryURL":"string"};
templates = exports;
return exports;

});

class DocumentLibrary extends Component {}
Soy.register(DocumentLibrary, templates);
export { DocumentLibrary, templates };
export default templates;
/* jshint ignore:end */
